const DEFAULT_BASE_ADDRESS = "http://127.0.0.1:8088";

/**
 * Sterowanie vMixem z poziomu nakładki (Browser Input działa na tej samej maszynie co vMix).
 * Każde wywołanie jest best-effort - błąd sieci nigdy nie może wywrócić widoku transmisji.
 */
class OverlayVmixHelper {
    constructor() {
        this._baseAddress = DEFAULT_BASE_ADDRESS;
        this._enabled = true;
    }

    /**
     * Konfiguracja z query stringu adresu nakładki, np. ?vmix=http://127.0.0.1:8088 albo ?vmix=off
     */
    configureFromQuery(query) {
        const value = query?.vmix;

        if (value === undefined || value === null || value === "") {
            this._baseAddress = DEFAULT_BASE_ADDRESS;
            this._enabled = true;
            return;
        }

        if (value === "off" || value === "false" || value === "0") {
            this._enabled = false;
            return;
        }

        this._baseAddress = value.replace(/\/+$/, "");
        this._enabled = true;
    }

    masterAudioOff() {
        this._call("MasterAudioOff");
    }

    masterAudioOn() {
        this._call("MasterAudioOn");
    }

    _call(functionName) {
        if (!this._enabled)
            return;

        try {
            fetch(`${this._baseAddress}/API/?Function=${functionName}&x=${Date.now()}`, {
                mode: "no-cors",
                cache: "no-store"
            }).catch(() => { });
        }
        catch {
            // vMix niedostępny - nakładka ma działać dalej
        }
    }
}

export default new OverlayVmixHelper();
